module.exports = __webpack_public_path__ + "static/Quirk-3d22329ad9875ff2295bd74bc04a1ff0.otf";